import React from 'react'

import NiceModal from '@ebay/nice-modal-react'
import { Stack, Text } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'

import { ModalShell, useModalControls } from '#components/Modals'
import { Toast } from '#components/Toast'
import { IOrg } from '#state'
import { delay } from '#util'

// oxlint-disable-next-line react/only-export-components
const UpgradeInquiry = ({ org }: { org: IOrg }) => {
  const controls = useModalControls()

  const { status, mutate: handleConfirm } = useMutation({
    mutationFn: () => org.upgradeInquiry(),
    onSuccess() {
      delay(1).then(controls.onClose)
    },
  })

  return (
    <ModalShell
      title="Request an upgrade"
      onConfirm={() => handleConfirm()}
      disabled={status !== 'idle'}
      confirmLabel="OK"
      cancelLabel="Cancel"
      size={350}
      opened={controls.opened}
      onClose={controls.onClose}
      loading={status === 'pending'}
      errorMessage={status === 'error' ? 'Failed to send inquiry' : null}
    >
      <Stack px={5} pt={5} pb={10}>
        {status === 'success' ? (
          <Toast
            message="Message received. We'll email you soon!"
            type="success"
            dismissable={false}
          ></Toast>
        ) : null}
        <Text>
          Would you like to learn more about our upgrade options and pricing
          plans?
        </Text>
        <Text>
          If so, we will follow up by email and share details with you.
        </Text>
      </Stack>
    </ModalShell>
  )
}

const UpgradeInquiryModal = NiceModal.create(UpgradeInquiry)

// See (./readme.md)
export const showUpgradeInquiryModal = (org: IOrg) =>
  NiceModal.show(UpgradeInquiryModal, { org })
